import currency, { default as Currency } from 'currency.js';

export const getCurrencySymbol = (currency: string, locale = 'en-US') =>
  // @ts-expect-error
  new Intl.NumberFormat(locale, { style: 'currency', currency }).formatToParts(1).find((x) => x.type === 'currency')
    .value;

export type FormatCurrencyOptions = {
  fromCents?: boolean;
  hideCurrencySymbol?: boolean;
};

export const formatCurrency = (
  amount: number | string | Currency,
  currencyId: string,
  opts?: FormatCurrencyOptions
) => {
  const amountNum = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
  const isWholeNumber = Number.isInteger(amountNum);

  const fromCents = opts?.fromCents ?? false;

  const value = fromCents ? currency(amount, { fromCents }).value : amountNum;

  const hideCurrencySymbol = opts?.hideCurrencySymbol;

  const formatter = new Intl.NumberFormat(undefined, {
    maximumFractionDigits: isWholeNumber ? 0 : 2,
    minimumFractionDigits: isWholeNumber ? 0 : 2,
    ...(!hideCurrencySymbol && {
      style: 'currency',
      currencyDisplay: 'narrowSymbol',
      currency: currencyId
    })
  });

  return formatter.format(value);
};

export const formatPriceAmount = (amount: number | string | Currency, locale = 'en-US') => {
  const value = currency(amount).value;

  const formatter = new Intl.NumberFormat(locale, {
    maximumFractionDigits: 2,
    minimumFractionDigits: currency(value).cents() > 0 ? 2 : 0
  });

  return formatter.format(value);
};
